import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client';
import { parse } from 'query-string';
import { Page, Row, Column } from 'components/shared/Layout';
import { Spinner } from 'admin-components/components';
import AgentPortalError from 'errors/AgentPortalError';
import { ACTION_CODES } from 'constants/errors';
import { SEARCH_VOUCHERS } from 'store/queries';
import { StyledH1, StyledH2 } from './VoucherList.styles';
import VouchersTable from './VouchersTable';

const VoucherList = ({ location: { search } }) => {
  const { recipientEmail } = parse(search);
  const { loading, error, data } = useQuery(SEARCH_VOUCHERS, {
    variables: {
      email: recipientEmail
    },
    fetchPolicy: 'network-only'
  });

  if (loading) {
    return (
      <Row span={16} height="100vh">
        <Column justifyContent="center" alignItems="center">
          <Spinner />
        </Column>
      </Row>
    );
  }

  if (error) {
    throw new AgentPortalError(error, ACTION_CODES.REDIRECT_TO_CUSTOM_PAGE, {
      errorCTARedirect: '/vouchers/manage'
    });
  }

  const { searchVouchers: vouchers } = data;

  return (
    <Page columns={20}>
      <Column span={18} start={2}>
        <StyledH1>
          <FormattedMessage id="vouchers.manageVoucher" />
        </StyledH1>
        <StyledH2>
          <FormattedMessage id="vouchers.searchByEmailResultsHeader" values={{ numberOfVouchers: vouchers.length }} />:
          <strong> {recipientEmail}</strong>
        </StyledH2>
        <VouchersTable vouchers={vouchers} />
      </Column>
    </Page>
  );
};

VoucherList.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired
};

export default withRouter(VoucherList);
